import React from 'react';

function DealList({ title, deals, type }) {
  return (
    <section className="py-10 px-4 bg-gradient-to-br from-blue-50 to-[#F5FFFA]">
      
      {/* Section Title */}
      <h2 className="text-2xl md:text-3xl font-bold text-orange-600 mb-6 text-center drop-shadow-sm">
        {title}
      </h2>

      {/* Deals Container */}
      <div className="max-w-4xl mx-auto space-y-4">
        {deals.map((d) => (
          <div
            key={d.id}
            className="bg-white rounded-xl shadow-md border border-orange-200 p-5 hover:shadow-xl transition-all duration-300"
          >
            {/* Deal Title */}
            <p className="text-lg font-semibold text-gray-800">
              {type === 'flight' ? d.route : d.name}
            </p>

            {/* Price */}
            <p className="text-xl font-bold text-blue-700 mt-1">
              ₹{d.price.toLocaleString()}
            </p>

            {/* Timestamp */}
            <p className="text-xs text-gray-500 mt-2">
              Updated: {new Date(d.lastUpdated).toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default DealList;
